import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Entity} from '../../product/product.model';
import {InstrumentTypeComponent} from '../../../components/instrument-type/instrument-type.component';
import {EntityListComponent} from '../../../components/entity-list/entity-list.component';
import {SystemService} from '../../../services/system.service';
import {InstrumentService} from '../../../components/instrument/instrument.service';
import {Subject} from 'rxjs';
import {takeUntil, tap} from 'rxjs/operators';
import {InstrumentModelComponent} from '../../../components/instrument-model/instrument-model.component';
import {InstrumentBrand, InstrumentModel} from '../../../interfaces/interfaces';

@Component({
  selector: 'instrument-model-page',
  templateUrl: './instrument-model-page.component.html',
  styleUrls: ['./instrument-model-page.component.scss']
})
export class InstrumentModelPageComponent implements OnInit, OnDestroy {
    instrumentModels: Entity[];
    instrumentModel: any;

    @ViewChild('instrumentModelComp')
    instrumentModelComp: InstrumentModelComponent;

    @ViewChild('entityList')
    entityList: EntityListComponent;

    private readonly _unsubscribeAll: Subject<any>;

    constructor(public _systemService: SystemService,  public _instrumentService: InstrumentService) {
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {

        this._instrumentService.allInstrumentModels$.pipe(
            takeUntil(this._unsubscribeAll),
            tap((data) => {
                this.instrumentModels = data;
            })
        ).subscribe();
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    selected(entity): void{
        this.instrumentModel = entity;
        this.instrumentModelComp.selected(entity);
    }


    newInstrumentModel(): void {
        this._instrumentService.updateInstrumentModel(new InstrumentModel()).subscribe(
            (newModel) => {
                this.instrumentModel = newModel;
                this.selected(newModel);

            },
            (error) => {
                console.error('Error al crear nuevo modelo:', error);
            }
        );
    }

     showNameAndType(entity: InstrumentModel): string {
        // const type = this._instrumentService.getInstrumentType(entity.familyId);

        return (entity.name ?? '') + ' (' + entity.brand?.name + '-' + entity.family?.name + ')';
    }


}
